import {
  FanClubSubmissionsDocument,
  UpdateFanClubSubmissionDocument,
} from "src/generated-gql/graphql";
import { gql } from "graphql-tag";
import { OnInit } from "@angular/core";
import {
  DataService,
  ModalService,
  NotificationService,
  TypedBaseListComponent,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { Component } from "@angular/core";

@Component({
  templateUrl: "./fan-club-submission-list.component.html",
  standalone: true,
  imports: [SharedModule],
})
export class FanClubSubmissionList
  extends TypedBaseListComponent<
    typeof FanClubSubmissionsDocument,
    "fanClubSubmissions"
  >
  implements OnInit
{
  constructor(
    protected dataService: DataService,
    private modalService: ModalService,
    private notificationService: NotificationService
  ) {
    super();
    super.configure({
      document: FanClubSubmissionsDocument,
      getItems: (data) => {
        return data.fanClubSubmissions;
      },
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            _and: [
              {
                _or: [
                  // {
                  //   isApproved: {
                  //     eq: false,
                  //   },
                  // },
                  {
                    isApproved: {
                      isNull: true,
                    },
                  },
                ],
                name: {
                  contains: this.searchTermControl.value,
                },
                ...this.filters.createFilterInput(),
              },
            ],
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.sorts.valueChanges,
        this.filters.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addDateFilters()
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSorts([
      { name: "id" },
      { name: "createdAt" },
      { name: "updatedAt" },
      { name: "name" },
      { name: "description" },
    ]);

  approve(entity: any) {
    this.dataService
      .mutate(UpdateFanClubSubmissionDocument, {
        input: {
          id: entity.id,
          isApproved: true,
        },
      })
      .subscribe(({}) => {
        this.notificationService.success("Approved.");
        this.refresh();
      });
  }

  reject(entity: any) {
    this.dataService
      .mutate(UpdateFanClubSubmissionDocument, {
        input: {
          id: entity.id,
          isApproved: false,
        },
      })
      .subscribe(({}) => {
        this.notificationService.success("Rejected.");
        this.refresh();
      });
  }

  deleteFanClub(id: string) {
    this.dataService
      .mutate(
        gql`
          mutation RemoveFanClub($id: ID!) {
            deleteFanClub(id: $id) {
              result
            }
          }
        `,
        { id }
      )
      .subscribe(() => {
        this.notificationService.success("Fan Club Deleted");
        this.refresh();
      });
  }
}
